import { render, staticRenderFns } from "./RTLSwitch.vue?vue&type=template&id=620e6a01&"
import script from "./RTLSwitch.vue?vue&type=script&lang=js&"
export * from "./RTLSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports